<div class="contained-loader-overlay">
  <div [ngClass]="{'blur-background': blurBackground }">
      <app-dynamic-loader [diameter]="diameter" [stroke]="stroke" [loaderType]="loaderType"></app-dynamic-loader>
  </div>
</div>
